import { Directive, Input, OnChanges, SimpleChanges, Output } from '@angular/core';
import { NotifyService } from '../../services/notify.service';

@Directive({
  selector: '[show]'
})
export class ShowDirective implements OnChanges {


  @Input('show') show: any;


  constructor(private notifyService: NotifyService) {
  }

  ngOnChanges(simpleChange: SimpleChanges) {
    this.notifyService.notify({ showStepper: simpleChange.show });
  }

}
